import styled from 'styled-components'
import {
  anatomyV2ContentWrapperCss,
  anatomyV2RootCss,
} from '~/pages/anatomyV2/libs/pageLayoutStyles'
import { Button } from '~/shared/components/Button'
import { COLORS } from '~/shared/constants/uiConstants'

export const AnatomyV2WhatWeExploredStyles = {
  Root: styled.div`
    ${anatomyV2RootCss}
  `,

  ContentWrapper: styled.div`
    position: relative;
    ${anatomyV2ContentWrapperCss}
    min-height: 0;
  `,

  ProgressWrapper: styled.div`
    padding: 16px 16px 0;
  `,

  ScrollContent: styled.div`
    position: relative;
    z-index: 3;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: 0 16px;
  `,

  Title: styled.h1`
    font-family: 'Mulish', sans-serif;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.2;
    color: ${COLORS.BLACK};
    margin: 24px 0 8px;
  `,

  Subtitle: styled.p`
    font-family: 'Mulish', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4;
    color: #787b7c;
    margin-bottom: 20px;
  `,

  SubtitleBold: styled.span`
    font-size: 14px;
    font-weight: 700;
    line-height: 1.4;
    color: #787b7c;
  `,

  ZonesWrapper: styled.div`
    margin-bottom: 16px;
  `,

  ZonesGrid: styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 200px;
    gap: 10px;
  `,

  BodyImageWrapper: styled.div`
    position: absolute;
    z-index: 1;
    top: 30px;
    right: -65px;
    height: clamp(420px, calc(100% - 30px), 520px);
  `,

  BodyImage: styled.img`
    display: block;
    height: 100%;
    width: auto;
  `,

  FadeOverlay: styled.div`
    position: absolute;
    z-index: 2;
    bottom: 0;
    left: 0;
    right: 0;
    height: 142px;
    background: linear-gradient(
      to bottom,
      rgba(239, 245, 247, 0) 0%,
      #eff5f7 100%
    );
    pointer-events: none;
  `,

  ZoneCard: styled.div<{ $isExplored: boolean; $width: number }>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 6px;
    width: ${({ $width }) => $width}px;
    flex-shrink: 0;
    min-height: 54px;
    padding: 8px;
    border-radius: 8px;
    background: ${COLORS.WHITE};
    opacity: ${({ $isExplored }) => ($isExplored ? 1 : 0.7)};
    pointer-events: none;
  `,

  ZonePercent: styled.span`
    font-family: 'Mulish', sans-serif;
    font-size: 17px;
    font-weight: 900;
    line-height: 1;
    color: #6e68ee;
  `,

  ZoneLabel: styled.span<{ $isExplored: boolean }>`
    font-family: 'Mulish', sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 1;
    color: ${({ $isExplored }) => ($isExplored ? '#000' : '#8b8b8b')};
  `,

  QuestionMarkIcon: styled.span`
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    border-radius: 10px;
    background: #dedfe0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Mulish', sans-serif;
    font-size: 12px;
    font-weight: 700;
    color: #a9abab;
  `,

  Legend: styled.div`
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 16px;
  `,

  LegendItem: styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    font-family: 'Mulish', sans-serif;
    font-size: 13px;
    font-weight: 500;
    color: ${COLORS.BLACK};
  `,

  LegendDot: styled.span<{ $isExplored?: boolean }>`
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ $isExplored }) =>
      $isExplored ? '#6E68EE' : 'transparent'};
  `,

  ButtonWrapper: styled.div`
    position: relative;
    z-index: 10;
    padding: 16px;
  `,

  StyledButton: styled(Button)`
    width: 100%;
  `,
}
